import { filter, set } from 'lodash';
import { sentenceCase } from 'change-case';
import { useState, useEffect } from 'react';
import { Link as RouterLink } from 'react-router-dom';
// material
import {
  Card,
  Table,
  Stack,
  Avatar,
  Button,
  Checkbox,
  TableRow,
  TableBody,
  TableCell,
  Container,
  Typography,
  TableContainer,
  TablePagination,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  Select,
  MenuItem,
  FormControl,
  InputLabel,
} from '@mui/material';
import IconButton from '@mui/material/IconButton';
import axios from 'axios';
// components
import Page from '../components/Page';
import Label from '../components/Label';
import Scrollbar from '../components/Scrollbar';
import Iconify from '../components/Iconify';
import SearchNotFound from '../components/SearchNotFound';
import { UserListHead, PaymentListToolbar, PaymentMoreMenu } from '../sections/@dashboard/user';



// ----------------------------------------------------------------------

const TABLE_HEAD = [
  { id: 'name', label: 'Name', alignRight: false },
  { id: 'email', label: 'Email', alignRight: false },
  { id: 'category', label: 'Category', alignRight: false },
  { id: 'paymentStatus', label: 'Payment Status', alignRight: false },
  { id: 'subscriptiontype', label: 'Subscription Type', alignRight: false },
  { id: 'annualsubscription', label: 'Annual Subscriptioin', alignRight: false },
  { id: 'longterm', label: '10 Years Long Term Subscription', alignRight: false },
  { id: 'lifetime', label: 'Lifetime Subscription', alignRight: false },
  { id: 'startdate', label: 'Subscription Start Date', alignRight: false },
  { id: 'expiry', label: 'Subscription End Date', alignRight: false },
  { id: 'reminder', label: 'Reminder Date', alignRight: false },
  { id: 'updatedby', label: 'Updated By', alignRight: false },
  { id: 'action', label: 'Action', alignRight: false },
];

// ----------------------------------------------------------------------

function descendingComparator(a, b, orderBy) {
  if (b[orderBy] < a[orderBy]) {
    return -1;
  }
  if (b[orderBy] > a[orderBy]) {
    return 1;
  }
  return 0;
}

function getComparator(order, orderBy) {
  return order === 'desc'
    ? (a, b) => descendingComparator(a, b, orderBy)
    : (a, b) => -descendingComparator(a, b, orderBy);
}

function applySortFilter(array, comparator, query, statusFilter) {
  const stabilizedThis = array.map((el, index) => [el, index]);
  stabilizedThis.sort((a, b) => {
    const order = comparator(a[0], b[0]);
    if (order !== 0) return order;
    return a[1] - b[1];
  });

  let filteredArray = stabilizedThis.map((el) => el[0]);

  // Apply text query filter
  if (query) {
    filteredArray = filteredArray.filter((user) =>
      user.email.toLowerCase().includes(query.toLowerCase())
    );
  }

  // Apply status filter
  if (statusFilter) {
    filteredArray = filteredArray.filter((user) =>
      user.paymentStatus.toLowerCase() === statusFilter.toLowerCase()
    );
  }

  return filteredArray;
}

export default function Payment() {
  const [page, setPage] = useState(0);
  const [order, setOrder] = useState('asc');
  const [selected, setSelected] = useState([]);
  const [orderBy, setOrderBy] = useState('name');
  const [filterName, setFilterName] = useState('');
  const [statusFilter, setStatusFilter] = useState('');
  const [rowsPerPage, setRowsPerPage] = useState(5);

  // State for users
  const [users, setUsers] = useState([]);
  const [editingUserId, setEditingUserId] = useState(null);
  const [openModal, setOpenModal] = useState(false);
  const [name, setName] = useState('');
  const [email, setEmail] = useState('');
  const [category, setCategory] = useState('');
  const [paymentStatus, setPaymentStatus] = useState('');
  const [subscriptiontype, setSubscriptionType] = useState('');
  const [annualsubscription, setAnnualSubscription] = useState('');
  const [longterm, setLongTerm] = useState('');
  const [lifetime, setLifetime] = useState('');
  const [subscriptionStartDate, setSubscriptionStartDate] = useState('');
  const [selectedUser, setSelectedUser] = useState(null);
  const [viewModalOpen, setViewModalOpen] = useState(false);





  // Fetch users from the server on component mount
  useEffect(() => {
    fetchUsers();
  }, []);

  // Fetch users from the server
  const fetchUsers = async () => {
    try {
      const response = await axios.get('https://form.cpccbe.org/api/payment/payments'); // Ensure this matches your backend endpoint
      setUsers(response.data);
    } catch (error) {
      console.error("Error fetching payments:", error);
    }
  };

  const handleRequestSort = (event, property) => {
    const isAsc = orderBy === property && order === 'asc';
    setOrder(isAsc ? 'desc' : 'asc');
    setOrderBy(property);
  };

  const handleSelectAllClick = (event) => {
    if (event.target.checked) {
      const newSelecteds = users.map((n) => n.email); // Use email as unique identifier
      setSelected(newSelecteds);
      return;
    }
    setSelected([]);
  };

  const handleClick = (event, email) => {
    const selectedIndex = selected.indexOf(email);
    let newSelected = [];
    if (selectedIndex === -1) {
      newSelected = newSelected.concat(selected, email);
    } else if (selectedIndex === 0) {
      newSelected = newSelected.concat(selected.slice(1));
    } else if (selectedIndex === selected.length - 1) {
      newSelected = newSelected.concat(selected.slice(0, -1));
    } else if (selectedIndex > 0) {
      newSelected = newSelected.concat(selected.slice(0, selectedIndex), selected.slice(selectedIndex + 1));
    }
    setSelected(newSelected);
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const handleFilterByName = (event) => {
    setFilterName(event.target.value);
  };

  // Handle opening and closing of modal for editing user
  const handleOpenModal = (userId) => {
    if (userId) {

      const userToEdit = users.find(user => user._id === userId);
      if (userToEdit) {
        setName(userToEdit.name);
        setEmail(userToEdit.email);
        setCategory(userToEdit.category);
        setPaymentStatus(userToEdit.paymentStatus);
        setSubscriptionType(userToEdit.subscriptiontype);
        setSubscriptionStartDate(userToEdit.startdate);
        setAnnualSubscription(userToEdit.annualsubscription);
        setLongTerm(userToEdit.longterm);
        setLifetime(userToEdit.lifetime);
        setEditingUserId(userId);
      }
    } else {
      setName('');
      setEmail('');
      setCategory('');
      setPaymentStatus('');
      setSubscriptionType('');
      setSubscriptionStartDate('');
      setAnnualSubscription('');
      setLongTerm('');
      setLifetime('');
      setEditingUserId(null);
    }
    setOpenModal(true);

  };


  const handleCloseModal = () => {
    setOpenModal(false);
    setName('');
    setEmail('');
    setCategory('');
    setPaymentStatus('');
    setSubscriptionType('');
    setSubscriptionStartDate('');
    setAnnualSubscription('');
    setLongTerm('');
    setLifetime('');
    setEditingUserId(null);

  };

  const handleViewUser = (user) => {
    setSelectedUser(user);
    setViewModalOpen(true);
  };




  // Handle updating a user
  const handleUpdateUser = async () => {
    const updatedby = localStorage.getItem('email');
    try {
      await axios.put(`https://form.cpccbe.org/api/payment/update-payment/${editingUserId}`, { email, category, paymentStatus, subscriptiontype, updatedby,annualsubscription, longterm, lifetime, subscriptionStartDate }); // Adjust endpoint as necessary
      fetchUsers(); // Refresh user list after updating
      handleCloseModal(); // Close modal after updating
    } catch (error) {
      console.error("Error updating payment:", error);
    }
  };

  // Handle deleting a user
  const handleDeleteUser = async (userId) => {
    if (window.confirm("Are you sure you want to delete this payment?")) {
      try {
        await axios.delete(`https://form.cpccbe.org/api/payment/delete-payment/${userId}`);
        fetchUsers(); // Refresh user list after deletion
      } catch (error) {
        console.error("Error deleting payment:", error);
      }
    }
  };

  const handleNotifyUser = async (userId) => {


    if (window.confirm("Are you sure you want to notify this user?")) {
      try {
        // Fetch user details to get email
        const userToNotify = users.find(user => user._id === userId);
        if (userToNotify) {
          const { email } = userToNotify;
          const paymentStatus = userToNotify.paymentStatus;

          await axios.post(`https://form.cpccbe.org/api/payment/notify/${userId}`, { email, paymentStatus });
          console.log("Payment Notified");
          fetchUsers(); // Refresh user list after notifying
        } else {
          console.error("User not found");
        }
      } catch (error) {
        console.error("Error notifying payment:", error);
      }
    }
  };



  const emptyRows = page > 0 ? Math.max(0, (1 + page) * rowsPerPage - users.length) : 0;

  // Apply sorting and filtering
  const filteredUsers = applySortFilter(users, getComparator(order, orderBy), filterName, statusFilter);


  const isUserNotFound = filteredUsers.length === 0;

  return (
    <Page title="Payment">
      <Container>
        <Stack direction="row" alignItems="center" justifyContent="space-between" mb={5}>
          <Typography variant="h4" gutterBottom>
            Payments
          </Typography>

        </Stack>

        <Card>
          <PaymentListToolbar
            numSelected={selected.length}
            filterName={filterName}
            onFilterName={handleFilterByName}
            statusFilter={statusFilter}
            onStatusFilterChange={(event) => setStatusFilter(event.target.value)}

          />




          <Scrollbar>
            <TableContainer sx={{ minWidth: 800 }}>
              <Table>
                <UserListHead
                  order={order}
                  orderBy={orderBy}
                  headLabel={TABLE_HEAD}
                  rowCount={users.length}
                  numSelected={selected.length}
                  onRequestSort={handleRequestSort}
                  onSelectAllClick={handleSelectAllClick}
                />
                <TableBody>
                  {filteredUsers.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage).map((row) => {
                    const { _id, name, email, category, paymentStatus, subscriptiontype, updatedby, annualsubscription, longterm, lifetime, subscriptionStartDate, subscriptionEndDate, reminderDate } = row; // Adjust based on your actual data structure
                    const isItemSelected = selected.indexOf(name) !== -1;

                    return (
                      <TableRow
                        hover
                        key={_id}
                        tabIndex={-1}
                        role="checkbox"
                        selected={isItemSelected}
                        aria-checked={isItemSelected}
                      >
                        <TableCell align="left">
                          <IconButton onClick={() => handleViewUser(row)} aria-label="view user">
                            <Iconify icon="eva:eye-fill" />
                          </IconButton>
                        </TableCell>
                        <TableCell align='left'>{name}</TableCell>
                        <TableCell align='left'>{email}</TableCell>
                        <TableCell align='left'>{category}</TableCell>
                        <TableCell align="left">{paymentStatus}</TableCell>
                        <TableCell align="left">{subscriptiontype || '-'}</TableCell>
                        <TableCell align="left">{annualsubscription}</TableCell>
                        <TableCell align="left">{longterm}</TableCell>
                        <TableCell align="left">{lifetime}</TableCell>
                        <TableCell align="left">{subscriptionStartDate || '-'}</TableCell>
                        <TableCell align="left">{subscriptionEndDate || '-'}</TableCell>
                        <TableCell align="left">{reminderDate || '-'}</TableCell>
                        <TableCell align="left">{updatedby}</TableCell>



                        <TableCell align="left">
                          <PaymentMoreMenu
                            onEdit={() => handleOpenModal(row._id)}
                            onDelete={() => handleDeleteUser(row._id)}
                            onNotify={() => handleNotifyUser(row._id)}
                          />
                        </TableCell>
                      </TableRow>
                    );
                  })}
                  {emptyRows > 0 && (
                    <TableRow style={{ height: 53 * emptyRows }}>
                      <TableCell colSpan={6} />
                    </TableRow>
                  )}
                </TableBody>

                {isUserNotFound && (
                  <TableBody>
                    <TableRow>
                      <TableCell align="center" colSpan={6} sx={{ py: 3 }}>
                        <SearchNotFound searchQuery={filterName} />
                      </TableCell>
                    </TableRow>
                  </TableBody>
                )}
              </Table>
            </TableContainer>
          </Scrollbar>

          <TablePagination
            rowsPerPageOptions={[5, 10, 25]}
            component="div"
            count={users.length}
            rowsPerPage={rowsPerPage}
            page={page}
            onPageChange={handleChangePage}
            onRowsPerPageChange={handleChangeRowsPerPage}
          />
        </Card>

        {/* Modal for Editing Payment */}
        <Dialog open={openModal} onClose={handleCloseModal}>
          <DialogTitle>Edit Payment</DialogTitle>
          <DialogContent>
            {/* Email Field */}
            <TextField
              label="Name"
              name="name"
              value={name}
              onChange={(e) => setName(e.target.value)}
              fullWidth
              margin="normal"

            />
            <TextField
              label="Email"
              name="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              fullWidth
              margin="normal"
            />
            <FormControl fullWidth margin="normal">
            <InputLabel>Category</InputLabel>
            <Select
              value={category}
              onChange={(e) => setCategory(e.target.value)}
              name="category"
              fullWidth
              displayEmpty
              margin="normal"
            >
              <MenuItem value="" disabled>Select Category</MenuItem>
              <MenuItem value="INDIVIDUAL">INDIVIDUAL</MenuItem>
              <MenuItem value="LIFE MEMBER">LIFE MEMBER</MenuItem>
              <MenuItem value="SENIOR CITIZEN">SENIOR CITIZEN</MenuItem>
              <MenuItem value="STUDENT">STUDENT</MenuItem>
              <MenuItem value="INDUSTRY">INDUSTRY</MenuItem>
              <MenuItem value="INSTITUTION">INSTITUTION</MenuItem>
              <MenuItem value="TRADE UNION">TRADE UNION</MenuItem>
              <MenuItem value="ASSOCIATION">ASSOCIATION</MenuItem>
            </Select>
            </FormControl>	
            
            <FormControl fullWidth margin="normal">
            <InputLabel>Payment Status</InputLabel>
            <Select
              value={paymentStatus}
              onChange={(e) => setPaymentStatus(e.target.value)}
              name="paymentstatus"
              fullWidth
              displayEmpty
              margin="normal"
            >
              <MenuItem value="" disabled>Select Payment Status</MenuItem>
              <MenuItem value="Pending">Pending</MenuItem>
              <MenuItem value="Completed">Completed</MenuItem>
              <MenuItem value="Failed">Failed</MenuItem>
            </Select>
            </FormControl>
            
            <FormControl fullWidth margin="normal">
            <InputLabel>Subscription Type</InputLabel>
            <Select
              value={subscriptiontype}
              onChange={(e) => setSubscriptionType(e.target.value)}
              name="subscriptiontype"
              fullWidth
              displayEmpty
              margin="normal"
            >
              <MenuItem value="" disabled>Select Subscription Type</MenuItem>
              <MenuItem value="Individual">Individual</MenuItem>
              <MenuItem value="Individual - Senior Citizen">Individual - Senior Citizen</MenuItem>
              <MenuItem value="Individual - Student">Individual - Student</MenuItem>
              <MenuItem value="Trade Union (5001+)">Trade Union (5001+)</MenuItem>
              <MenuItem value="Trade Union (3001+)">Trade Union (3001+)</MenuItem>
              <MenuItem value="Trade Union(Upto 3000)">Trade Union(Upto 3000)</MenuItem>
              <MenuItem value="Institution">Institution</MenuItem>
              <MenuItem value="Association">Association</MenuItem>
              <MenuItem value="Industry(3001+)">Industry(3001+)</MenuItem>
              <MenuItem value="Industry(1001-3000)">Industry(1001-3000)</MenuItem>
              <MenuItem value="Industry(501-1000)">Industry(501-1000)</MenuItem>
              <MenuItem value="Industry(Upto 500)">Industry(Upto 500)</MenuItem>

            </Select>
            </FormControl>


            
            <TextField
              label="Subscription Start Date"
              name="subscriptionStartDate"
              type="date"
              value={subscriptionStartDate}
              onChange={(e) => setSubscriptionStartDate(e.target.value)}
              fullWidth
              margin="normal"
            />
        
            <FormControl fullWidth margin="normal"> 
            <InputLabel>Annual Subscription</InputLabel>
            <Select
              value={annualsubscription}
              onChange={(e) => setAnnualSubscription(e.target.value)}
              name="annualsubscription"
              fullWidth
              displayEmpty
              margin="normal"
            >
              <MenuItem value="" disabled>Select Annual Subscription</MenuItem>
              <MenuItem value="Yes">Yes</MenuItem>
              <MenuItem value="No">No</MenuItem>

            </Select>
            </FormControl>

            <FormControl fullWidth margin="normal">
            <InputLabel>10 Years Long Term Subscription</InputLabel>
            <Select
              value={longterm}
              onChange={(e) => setLongTerm(e.target.value)}
              name="longterm"
              fullWidth
              displayEmpty
              margin="normal"
            >
              <MenuItem value="" disabled>Select 10 Years Long Term Subscription</MenuItem>
              <MenuItem value="Yes">Yes</MenuItem>
              <MenuItem value="No">No</MenuItem>
            </Select>
            </FormControl>

            <FormControl fullWidth margin="normal">
            <InputLabel>Lifetime Subscription</InputLabel>
            <Select
              value={lifetime}
              onChange={(e) => setLifetime(e.target.value)}
              name="lifetime"
              fullWidth
              displayEmpty
              margin="normal"
            >
              <MenuItem value="" disabled>Select Lifetime Subscription</MenuItem>
              <MenuItem value="Yes">Yes</MenuItem>
              <MenuItem value="No">No</MenuItem>
            </Select>
            </FormControl>



          </DialogContent>
          <DialogActions>
            <Button onClick={handleCloseModal}>Cancel</Button>
            <Button onClick={handleUpdateUser}>Update Payment</Button>

          </DialogActions>
        </Dialog>

        {/* Modal for Viewing Payment */}
        <Dialog open={viewModalOpen} onClose={() => setViewModalOpen(false)}>
          <DialogTitle>Payment Details</DialogTitle>
          <DialogContent>
            <TextField
              label="Name"
              name="name"
              value={selectedUser ? selectedUser.name : ''}
              fullWidth
              margin="normal"
              disabled
            />
            <TextField
              label="Email"
              name="email"
              value={selectedUser ? selectedUser.email : ''}
              fullWidth
              margin="normal"
              disabled
            />
            <TextField
              label="Category"
              name="category"
              value={selectedUser ? selectedUser.category : ''}
              fullWidth
              margin="normal"
              disabled
            />
            <TextField
              label="Payment Status"
              name="paymentStatus"
              value={selectedUser ? selectedUser.paymentStatus : ''}
              fullWidth
              margin="normal"
              disabled
            />
            <TextField
              label="Subscription Type"
              name="subscriptiontype"
              value={selectedUser ? selectedUser.subscriptiontype : ''}
              fullWidth
              margin="normal"
              disabled
            />



            <TextField
              label="10 Years Long Term Subscription"
              name="longterm"
              value={selectedUser ? selectedUser.longterm : ''}
              fullWidth
              margin="normal"
              disabled
            />
            <TextField
              label="Lifetime Subscription"
              name="lifetime"
              value={selectedUser ? selectedUser.lifetime : ''}
              fullWidth
              margin="normal"
              disabled
            />
      <TextField
      label="Subscription Start Date"
      name="subscriptionStartDate"
      value={
        selectedUser && selectedUser.subscriptionStartDate 
          ? new Date(selectedUser.subscriptionStartDate).toISOString().split('T')[0] 
          : ''
        }
      fullWidth
      margin="normal"
      disabled
    />
          <TextField
      label="Subscription End Date"
      name="subscriptionEndDate"
      value={
        selectedUser && selectedUser.subscriptionEndDate 
          ? new Date(selectedUser.subscriptionEndDate).toISOString().split('T')[0] 
          : ''
        }
      fullWidth
      margin="normal"
      disabled
    />

<TextField
      label="Reminder Date"
      name="reminderDate"
      value={
        selectedUser && selectedUser.reminderDate 
          ? new Date(selectedUser.reminderDate).toISOString().split('T')[0] 
          : ''
        }
      fullWidth
      margin="normal"
      disabled
    />

            <TextField
              label="Updated By"
              name="updatedby"
              value={selectedUser ? selectedUser.updatedby : ''}
              fullWidth
              margin="normal"
              disabled
            />
          </DialogContent>
          <DialogActions>
            <Button onClick={() => setViewModalOpen(false)}>Close</Button>
          </DialogActions>
        </Dialog>
      </Container>
    </Page>
  );
}
